import { Clickable } from '@carvana/merch-components';
import classnames from 'classnames';
import { useContext } from 'react';
import useSendOpenModalEvent, {
  OpenSource
} from '@/SearchResults/ResultTileV2/useSendOpenModalEvent';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useVehicleContext } from '~/contexts/VehicleContext';
import EvCreditPill from './EvCreditPill';
import { hasCleanTaxCredit } from '../ResultTile.helpers';

const Pills = () => {
  const { vehicle } = useVehicleContext();
  const showEvPill = hasCleanTaxCredit(vehicle);
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const sendOpenEvent = useSendOpenModalEvent();

  return (
    <Clickable
      data-analytics-id={null}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        sendOpenEvent(OpenSource.EvTax);
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.EvTax,
          vehicleId: vehicle.vehicleId
        });
      }}
      className={classnames(
        showEvPill ? 'flex' : 'hidden',
        'absolute bottom-[-200px] right-[16px] pointer-events-auto'
      )}
    >
      <EvCreditPill />
    </Clickable>
  );
};

export default Pills;
